module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-152x152-ff5fc55912a6701d6331d5b368005b14.png";